import { fromJS, List, Map, Set as ImmutableSet } from 'immutable';

import { IRequestStatus } from '../../declarations';
import { AgentResaleOfferPortalActions } from './actionTypeMap';
import * as actionTypes from './actionTypes';

export const initialState = fromJS({
  agent: null,
  agentError: null,
  documentsWithUploadErrors: ImmutableSet(),
  failedUploadS3Keys: List([]),
  isLoadingAgent: false,
  isLoadingListing: false,
  listing: null,
  listingError: null,
  listingOffer: null,
  listingOfferError: null,
  offerDetails: null,
  offerSubmissionCompleted: false,
  typedAgentEmail: '',
  typedAgentFullName: '',
  typedAgentPhoneNumber: '',
  uploadOfferDocumentsRequests: Map(),
});

export default function reducer(state = initialState, action: AgentResaleOfferPortalActions) {
  switch (action.type) {
    case actionTypes.ERROR_AGENT:
      return state.merge({
        agentError: action.payload.agentError,
      });
    case actionTypes.ERROR_LISTING:
      return state.merge({
        listingError: action.payload.listingError,
      });
    case actionTypes.ERROR_LISTING_OFFER:
      return state.merge({
        listingOfferError: action.payload.listingOfferError,
      });
    case actionTypes.GET_LISTING:
      return state.merge({
        isLoadingListing: true,
        offerSubmissionCompleted: false,
      });
    case actionTypes.SET_LISTING:
      return state.merge({
        isLoadingListing: false,
        listing: fromJS(action.payload.listing),
      });
    case actionTypes.SET_LISTING_OFFER:
      return state.merge({
        listingOffer: fromJS(action.payload.listingOffer),
      });
    case actionTypes.GET_AGENT:
      return state.merge({
        isLoadingAgent: true,
        offerSubmissionCompleted: false,
      });
    case actionTypes.SET_AGENT:
      return state.merge({
        agent: fromJS(action.payload.agent),
        isLoadingAgent: false,
      });
    case actionTypes.SET_TYPED_AGENT_EMAIL:
      return state.merge({
        typedAgentEmail: fromJS(action.payload.typedAgentEmail),
      });
    case actionTypes.SET_TYPED_AGENT_FULL_NAME:
      return state.merge({
        typedAgentFullName: fromJS(action.payload.typedAgentFullName),
      });
    case actionTypes.SET_TYPED_AGENT_PHONE_NUMBER:
      return state.merge({
        typedAgentPhoneNumber: fromJS(action.payload.typedAgentPhoneNumber),
      });
    case actionTypes.SUBMIT_LISTING_OFFER:
      return state.merge({
        offerDetails: fromJS(action.payload.offerDetails),
        offerSubmissionCompleted: false,
      });
    case actionTypes.SET_OFFER_SUBMISSION_COMPLETED:
      return state.merge({
        offerSubmissionCompleted: true,
      });
    case actionTypes.ERROR_ON_GET_DOCUMENT_UPLOAD_URL:
      return state.merge({
        failedUploadS3Keys: state.getIn(['failedUploadS3Keys']).push(action.payload.s3Key),
      });
    case actionTypes.BEGIN_DOCUMENT_UPLOAD:
      return state.merge({
        uploadOfferDocumentsRequests: state
          .get('uploadOfferDocumentsRequests')
          .set(action.payload.s3Key, { isLoading: true, error: undefined } as IRequestStatus),
      });
    case actionTypes.DELETE_DOCUMENT: {
      const documentType = action.payload.fileTypeId;
      return state.merge({
        documentsWithUploadErrors: state.get('documentsWithUploadErrors').remove(documentType),
      });
    }
    case actionTypes.DOCUMENT_UPLOAD_SUCCESS: {
      const documentType = action.payload.fileTypeId;
      return state.merge({
        documentsWithUploadErrors: state.get('documentsWithUploadErrors').remove(documentType),
        uploadOfferDocumentsRequests: state
          .get('uploadOfferDocumentsRequests')
          .set(action.payload.s3Key, { isLoading: false, error: undefined } as IRequestStatus),
      });
    }
    case actionTypes.ERROR_ON_DOCUMENT_UPLOAD: {
      const documentType = action.payload.fileTypeId;
      return state.merge({
        documentsWithUploadErrors: state.get('documentsWithUploadErrors').add(documentType),
        uploadOfferDocumentsRequests: state
          .get('uploadOfferDocumentsRequests')
          .set(action.payload.s3Key, {
            error: action.payload.error,
            isLoading: false,
          } as IRequestStatus),
      });
    }
    default:
      return state;
  }
}
